import { apiFetch } from './client';

export const getDashboard = () => apiFetch('/api/dashboard');
